import React from 'react'
import version from '../version'

class Footer extends React.PureComponent {
  render = () => (
    <footer>
      <div id='pwd_reminder'>
        <p>
          <a target='_blank' href='https://www.nlg.gr/faq/#katigoria-04'>
            {this.props.polyglot.t('faq')}
          </a>
        </p>
        <p>
          <span id='lang'>
            <a
              className={
                this.props.polyglot.locale() === 'el' ? 'inactive' : null
              }
              href='#'
              onClick={e => {
                e.preventDefault()
                this.props.handleLang('el')
              }}
            >
              {this.props.polyglot.t('lang.el')}
            </a>
            <span className='tab' />
            <a
              className={
                this.props.polyglot.locale() === 'en' ? 'inactive' : null
              }
              href='#'
              onClick={e => {
                e.preventDefault()
                this.props.handleLang('en')
              }}
            >
              {this.props.polyglot.t('lang.en')}
            </a>
          </span>
        </p>
      </div>
      <div id='copyright'>
        {this.props.polyglot.t('copyright')}{' '}
        <a target='_blank' href={this.props.url.privacyPolicy}>
          {this.props.polyglot.t('privacyPolicy')}
        </a>{' '}
        <span id='version'>
          {this.props.polyglot.t('version', { version: version })}{' '}
          {this.props.polyglot.t('versionBackend', {
            version: this.props.backendVersion
          })}
        </span>
      </div>
    </footer>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/footer.js